import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
import styled, { css } from 'styled-components';
import { variant } from 'styled-system';
import { get } from '../../styles/constant';
import Icon from '../Icon';
const notificationVariants = variant({
  prop: 'variant',
  variants: {
    info: {
      backgroundColor: get('colors.feedback.info.light')
    },
    success: {
      backgroundColor: get('colors.feedback.success.light')
    },
    warning: {
      backgroundColor: get('colors.feedback.warning.light')
    },
    error: {
      backgroundColor: get('colors.feedback.danger.light')
    }
  }
});
const notificationSizes = variant({
  prop: 'fit',
  variants: {
    small: {
      fontSize: get('fontSizes.xs'),
      lineHeight: get('lineHeights.xs'),
      padding: props => "".concat(get('space.6')(props), " ").concat(get('space.12')(props)),
      borderRadius: get('borderRadius.s')
    },
    medium: {
      fontSize: get('fontSizes.s'),
      lineHeight: get('lineHeights.s'),
      padding: props => "".concat(get('space.10')(props), " ").concat(get('space.16')(props)),
      borderRadius: get('borderRadius.m')
    },
    large: {
      fontSize: get('fontSizes.m'),
      lineHeight: get('lineHeights.m'),
      padding: props => "".concat(get('space.12')(props), " ").concat(get('space.20')(props)),
      borderRadius: get('borderRadius.l')
    }
  }
});
const notificationMarginSizes = variant({
  prop: 'fit',
  variants: {
    small: {
      margin: props => "".concat(get('space.2')(props), " 0")
    },
    medium: {
      margin: props => "".concat(get('space.2')(props), " 0")
    },
    large: {
      margin: props => "".concat(get('space.4')(props), " 0")
    }
  }
});
const notificationIconSizes = variant({
  prop: 'fit',
  variants: {
    small: {
      margin: props => "0 ".concat(get('space.8')(props), " 0 0")
    },
    medium: {
      margin: props => "".concat(get('space.2')(props), " ").concat(get('space.12')(props), " 0 0")
    },
    large: {
      margin: props => "".concat(get('space.4')(props), " ").concat(get('space.12')(props), " 0 0")
    }
  }
});
const variants = {
  notificationVariants,
  notificationSizes,
  notificationMarginSizes,
  notificationIconSizes
};
const styles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  border-radius: ", ";\n  flex-direction: row;\n  padding: ", " ", ";\n  > ", " {\n    ", "\n  }\n"])), get('space.4'), get('space.8'), get('space.16'), Icon, variants.notificationIconSizes);
const Body = styled.div.attrs(_ref => {
  let {
    fit
  } = _ref;
  return {
    fit
  };
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  line-height: ", ";\n"])), variants.notificationMarginSizes, get('lineHeights.20'));
const Content = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"])));
const Heading = styled.div.attrs(_ref2 => {
  let {
    fit
  } = _ref2;
  return {
    fit
  };
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n  line-height: ", ";\n  font-weight: ", ";\n"])), variants.notificationMarginSizes, get('lineHeights.20'), get('fontWeights.bold'));
const Actions = styled.div.attrs(_ref3 => {
  let {
    fit
  } = _ref3;
  return {
    fit
  };
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n  display: flex;\n  line-height: ", ";\n"])), variants.notificationMarginSizes, get('lineHeights.20'));
const LinkWrapper = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin-right: ", ";\n  &:after {\n    padding-left: ", ";\n    content: '\u2022';\n  }\n  &:last-child {\n    :after {\n      content: '';\n    }\n  }\n"])), get('space.8'), get('space.6'));
const Link = styled.a(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  color: ", ";\n  text-decoration: underline;\n"])), get('colors.functional.grey.900'));
const CloseButton = styled.button(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  background: none;\n  border: none;\n  padding: ", ";\n  height: 100%;\n  display: inline-flex;\n  cursor: pointer;\n"])), get('space.4'));
const Wrapper = styled.div.attrs(_ref4 => {
  let {
    children
  } = _ref4;
  return {
    children
  };
})(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n"])), styles, variants.notificationVariants, variants.notificationSizes);
const Components = {
  Wrapper,
  Body,
  Content,
  Heading,
  Actions,
  LinkWrapper,
  Link,
  CloseButton
};
export { styles, variants, Components };